module.exports = __webpack_public_path__ + "static/media/img_doctor_null.6ad57c06.svg";